import styled from "styled-components";
import { palette } from "styled-theme";

const StepsWizardWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
   .closeBtn {
    position: absolute;
    left: ${(props) => (props["direction"] === "rtl" ? "10px" : "inherit")};
    right: ${(props) => (props["direction"] === "ltr" ? "10px" : "inherit")};
  }
  .steps {
    border-bottom: 1px solid ${palette("border", 0)};
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    padding: 16px;
    .ant-steps {
      width: 400px;
    }

    .ant-steps-item-wait, .ant-steps-item-finish {
      &:hover {
        .ant-steps-item-icon {
       border-color:#F5A522 !important;
     }
     span {
       color: #F5A522 !important;
     }
     }
    }

    .ant-steps-item-icon {
      /* font-size: 14px; */
      border-color:#F5A522;
     }
    .ant-steps-item-process .ant-steps-item-icon{
      background:#F5A522;

    }
     .ant-steps-item-icon > .ant-steps-icon{
       color:#F5A522;
     }
     .ant-steps-item-process .ant-steps-item-icon .ant-steps-icon{
       color:#ffffff;
     }
     .ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title::after{
       background-color:#F5A522;

     }
  }
  .ant-radio-button-wrapper{
    margin: 0 10px;
    border-radius: 5px !important;
    border-width:1px !important;
    padding: 20px;
    align-items: center;
    justify-content: center;
    display: flex;
  }
  .ant-radio-button-wrapper.ant-radio-button-wrapper-rtl.ant-radio-button-wrapper:not(:first-child)::before{
    width:0;
  }
  .inner{
    width: 100%;
    padding: 0 80px;
     .header {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 32px 0 40px 0;
      .ant-typography + h4.ant-typography {
        margin: 0;
        font-weight: 400;
        color: #7b7b7b;
      }
      h2.ant-typography{
        margin: 0 0 12px 0;
      }
    }
    .form {
      display: flex;
      justify-content: center;
      align-items: center;
        form {
          width: 100%;
          padding: 0 20px;
        }
        ul {
          margin:0;
        }
    }
      .actions {
        padding: 20px 0 40px 0;
        display: flex;
        align-items: center;
        justify-content: center;
        button {
          margin:0 5px;
        }
      }
  }
  }
`;

export default StepsWizardWrapper;
